/**
 * Generates an integer checksum for a string.  Useful for returning a
 * predictable number that can be modulated to pick a beauty mark.
 */
export function checksum(s: string): number {
  // Makes the result a fixed length
  let chk = 0x12345678;

  for (let i = 0; i < s.length; i++) {
    /**
     * This line accomplishes two things,
     * - First we convert the char to a number
     *   result in the same number.
     */

    // abcd, bcda will have same checksum
    // Collection-1 and Collection-2 will NOT have same checksum.
    chk += s.charCodeAt(i);
  }

  return chk;
}
